import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../../models/caseview.model';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-pull-file',
  templateUrl: './pull-file.component.html',
  styleUrls: ['./pull-file.component.scss'],
})
export class PullFileComponent implements OnInit {
  message: any;
  docId: any;
  jobId: any;
  fileId: any;
  getappType: number;
  jobID: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialogRef: MatDialogRef<PullFileComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {}

  onRecall(): void {
    const caseDataArray = this.data?.selectedData;
    const apiList = [];

    caseDataArray.forEach((data) => {
      if (data.jobId) {
        data.jobID = data.jobId;
        this.jobID = data.jobID.value;
      } else {
        this.jobID = data.jobID.value;
      }
      if (data.corrID) {
        data.fileId = data.corrID;
        this.getappType = 3;
      } else {
        this.getappType = 1;
      }

      const dataForPost = {
        recId: data.fileId,
        appTypeId: this.getappType,
        jobId: this.jobID,
      };
      const api = this.http.post('/workflow/pull-fr-case', dataForPost).pipe(
        map((r) => !!r),
        catchError((e) => of(false))
      );
      apiList.push(api);
    });
    forkJoin(apiList).subscribe((resArr: boolean[]) => {
      const anySuccess = resArr.some((r) => !!r);

      this.dialogRef.close(anySuccess);
    });
  }
}
